// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type RedirectToActiveStageQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type RedirectToActiveStageQuery = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', id: string, latestActiveStage?: { __typename?: 'ProjectStage', id: string, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } } | null | undefined }
    | { __typename?: 'Region', id: string, latestActiveStage?: { __typename?: 'ProjectStage', id: string, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } } | null | undefined }
    | { __typename?: 'Market', id: string, latestActiveStage?: { __typename?: 'ProjectStage', id: string, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } } | null | undefined }
    | { __typename?: 'Community', id: string, latestActiveStage?: { __typename?: 'ProjectStage', id: string, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } } | null | undefined }
    | { __typename?: 'Subdivision', id: string, latestActiveStage?: { __typename?: 'ProjectStage', id: string, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } } | null | undefined }
    | { __typename?: 'Lot', id: string, latestActiveStage?: { __typename?: 'ProjectStage', id: string, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } } | null | undefined }
    | { __typename?: 'Structure', id: string, latestActiveStage?: { __typename?: 'ProjectStage', id: string, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } } | null | undefined }
    | { __typename?: 'Unit', id: string, latestActiveStage?: { __typename?: 'ProjectStage', id: string, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } } | null | undefined }
   };


export const RedirectToActiveStageDocument = gql`
    query RedirectToActiveStage($projectId: ID!) {
  project(id: $projectId) {
    id
    latestActiveStage {
      id
      stage {
        code
        name
      }
    }
  }
}
    `;

/**
 * __useRedirectToActiveStageQuery__
 *
 * To run a query within a React component, call `useRedirectToActiveStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedirectToActiveStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedirectToActiveStageQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRedirectToActiveStageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RedirectToActiveStageQuery, RedirectToActiveStageQueryVariables> & ({ variables: RedirectToActiveStageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RedirectToActiveStageQuery, RedirectToActiveStageQueryVariables>(RedirectToActiveStageDocument, options);
      }
export function useRedirectToActiveStageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RedirectToActiveStageQuery, RedirectToActiveStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RedirectToActiveStageQuery, RedirectToActiveStageQueryVariables>(RedirectToActiveStageDocument, options);
        }
// @ts-ignore
export function useRedirectToActiveStageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RedirectToActiveStageQuery, RedirectToActiveStageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RedirectToActiveStageQuery, RedirectToActiveStageQueryVariables>;
export function useRedirectToActiveStageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RedirectToActiveStageQuery, RedirectToActiveStageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RedirectToActiveStageQuery | undefined, RedirectToActiveStageQueryVariables>;
export function useRedirectToActiveStageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RedirectToActiveStageQuery, RedirectToActiveStageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RedirectToActiveStageQuery, RedirectToActiveStageQueryVariables>(RedirectToActiveStageDocument, options);
        }
export type RedirectToActiveStageQueryHookResult = ReturnType<typeof useRedirectToActiveStageQuery>;
export type RedirectToActiveStageLazyQueryHookResult = ReturnType<typeof useRedirectToActiveStageLazyQuery>;
export type RedirectToActiveStageSuspenseQueryHookResult = ReturnType<typeof useRedirectToActiveStageSuspenseQuery>;
export type RedirectToActiveStageQueryResult = ApolloReactCommon.QueryResult<RedirectToActiveStageQuery, RedirectToActiveStageQueryVariables>;